import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {NotificationsService} from '@catcore/services';
import {RestHttpService} from '@catcore/services/rest-http.service';
import {ROLE, UserService} from '@catcore/services/user.service';
import {GenericResourceService} from '@catfeatures/services/generic-resource.service';
import {UserNote} from '@catmodules/widgets/user-notes/types/user-note';
import {StyleType} from '@catui/types';
import {ISubscription} from "rxjs/Subscription";
import {ConfirmationService, Editor} from "primeng/primeng";
import {DisplayTypes} from "@catui/components/panel/types";

@Component({
  selector: 'cat-user-notes',
  templateUrl: './user-notes.component.html',
  styleUrls: ['./user-notes.component.scss'],
})
export class UserNotesComponent implements OnInit, OnDestroy {
  @Input() title?: string = 'Notes';
  @Input() restService: RestHttpService<any>;

  panelDisplayType = DisplayTypes;
  userNotes: UserNote[];

  newNoteContent: string;
  subscription: ISubscription;
  id: number;
  styleType = StyleType;
  role = ROLE;
  editBackupMap: Map<string, string> = new Map();

  constructor(
    private genericResourceService: GenericResourceService,
    private userService: UserService,
    private notificationService: NotificationsService,
    private confirmationService: ConfirmationService,
  ) {}

  ngOnInit(): void {
    this.subscription = this.restService.getCurrent().subscribe((entity) => {
      if (entity) {
        this.userNotes = ((entity || {})._embedded || {}).user_notes || [];
        this.id = entity.id;
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onAdd() {
    if (!this.newNoteContent) {
      this.notificationService.error('Note empty!', 'Please add content to the note.');
      return;
    }
    this.userNotes.push({
      content: this.newNoteContent,
    });
    const subscription = this.restService.update( { id: this.id, user_notes: this.userNotes})
      .finally(() => subscription.unsubscribe())
      .subscribe((result) => {
        this.notificationService.success('Note added!', 'The note has been added successfully.');
        this.newNoteContent = '';
        this.restService.setCurrent(result);
      });
  }

  onDelete(userNote: UserNote) {
    this.confirmationService.confirm({
      message: 'Do you really want to delete this note?',
      accept: () => {
        this.genericResourceService.findServiceForResource(userNote._links.self.href).delete().subscribe((value) => {
          this.notificationService.success('Note deleted!', 'The note has been deleted successfully.');
          this.restService.refreshCurrent();
        });
      }
    });

  }

  onEdit(userNote: UserNote, editor: Editor) {
    console.log("on edit");
    if (editor.readonly) {
      this.setEditorReadonly(editor, false);
      this.editBackupMap.set(userNote._links.self.href, userNote.content);
    } else {
      this.genericResourceService.findServiceForResource(userNote._links.self.href).save(userNote).subscribe((value) => {
        this.notificationService.success('Note updated!', 'The note has been updated successfully.');
        this.restService.refreshCurrent();
        this.setEditorReadonly(editor, true);
        this.editBackupMap.delete(userNote._links.self.href);
      });
    }
  }

  onCancel(userNote: UserNote, editor: Editor) {
    this.setEditorReadonly(editor, true);
    userNote.content = this.editBackupMap.get(userNote._links.self.href);
    this.editBackupMap.delete(userNote._links.self.href);
  }

  setEditorReadonly(editor: Editor, readOnly: boolean) {
    editor.readonly = readOnly;
    if (readOnly) {
      editor.el.nativeElement.classList.add('read-only-editor');
    } else {
      editor.el.nativeElement.classList.remove('read-only-editor');
    }
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/widgets/user-notes/components/user-notes.component.ts